import { render, staticRenderFns } from "./Aparts.vue?vue&type=template&id=6a44e18a"
import script from "./Aparts.vue?vue&type=script&lang=js"
export * from "./Aparts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports